import { useState } from 'react'

type DialogState<T extends string> = T | 'none'

export function useDialogState<T extends string>(initialState: DialogState<T>) {
  const [dialogState, setDialogState] = useState<DialogState<T>>('none')

  const closeDialog = () => setDialogState('none')

  return {
    dialogState,
    setDialogState,
    closeDialog,
  }
}
